import { PackageCheck, Stethoscope, Wrench, Truck } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Send inn enheten",
    desc: "Pakk enheten godt og send den til oss. Du finner adressen i kontaktskjemaet.",
    Icon: PackageCheck,
    testId: "step-1",
  },
  {
    n: "02",
    title: "Vi diagnostiserer",
    desc: "Når enheten ankommer, gjør vi en grundig feilsøking og sender deg et uforpliktende pristilbud.",
    Icon: Stethoscope,
    testId: "step-2",
  },
  {
    n: "03",
    title: "Reparasjon utføres",
    desc: "Etter at du har godkjent tilbudet, utfører vi reparasjonen med kvalitetssikrede deler.",
    Icon: Wrench,
    testId: "step-3",
  },
  {
    n: "04",
    title: "Returneres trygt",
    desc: "Vi sender enheten tilbake — testet, rengjort og klar til bruk.",
    Icon: Truck,
    testId: "step-4",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="slik-fungerer-det"
      className="py-24 md:py-32 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="text-xs uppercase tracking-[0.18em] text-[#86868B]">
              Slik fungerer det
            </span>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-[#1D1D1F]">
              Fire enkle steg.
              <br />
              <span className="text-[#86868B]">Null stress.</span>
            </h2>
            <p className="mt-5 text-lg text-[#1D1D1F]/70 leading-relaxed">
              Vi har gjort prosessen så enkel som mulig. Du trenger ikke forlate
              hjemmet — alt skjer via post.
            </p>
            <div className="mt-8 rounded-2xl overflow-hidden border border-black/[0.05]">
              <img
                src="https://images.pexels.com/photos/4440891/pexels-photo-4440891.jpeg"
                alt="Pakke klar for postforsendelse"
                className="w-full h-64 object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <ol className="lg:col-span-7 space-y-3">
            {steps.map(({ n, title, desc, Icon, testId }) => (
              <li
                key={n}
                className="relative flex gap-6 rounded-3xl border border-black/[0.06] bg-white p-7 md:p-8 transition-all duration-300 hover:bg-[#F5F5F7]/60"
                data-testid={testId}
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#1D1D1F] text-white">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-medium tracking-wider text-[#86868B]">
                    Steg {n}
                  </div>
                  <h3 className="font-display mt-1 text-xl md:text-2xl font-semibold tracking-tight text-[#1D1D1F]">
                    {title}
                  </h3>
                  <p className="mt-2 text-[15px] text-[#1D1D1F]/70 leading-relaxed">
                    {desc}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
